import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
// DATE FORMATTERS
import {
  format, add, isWeekend, isFriday,
} from 'date-fns';
import Holidays from '@/utils/Holidays';
// COMPONENTS
import Title from './Components/Title';
import Address from './Components/Address';
import StepperButtons from '../StepperButtons';
import BoxCheckout from './Components/BoxCheckout';
import RadioGroupPayment from './Components/RadioGroupPayment';
// FUNCTIONS
import connect from './ConnectComponentRedux';
import { propTypes, defaultProps } from './PropTypes';
import LaterPaymentMethod from './Components/LaterPaymentMethod';
import AfterRepairPaymentMethod from './Components/AfterRepairPaymentMethod';

function PaymentMethod({ $state, $actions }) {
  const { billingAddress } = $state;
  const creditCardRef = React.useRef(null);
  const laterPaymentRef = React.useRef(null);
  const afterRepairPaymentRef = React.useRef(null);

  const [methodSelect, setMethodSelect] = React.useState($state.payment.type || 'afterRepairPayment');
  const [isSubmitting, setSubmitting] = React.useState(null);
  const refs = {
    creditCard: creditCardRef,
    laterPayment: laterPaymentRef,
    afterRepairPayment: afterRepairPaymentRef,
  };

  const handleRadioChange = ({ currentTarget }) => (
    setMethodSelect(currentTarget?.value)
  );

  const formik = useFormik({
    initialValues: {
      address: billingAddress,
    },
    validationSchema: Yup.object({
      address: Yup.object(Address.rules),
    }),
    onSubmit: async ({ address }) => {
      $actions.setBillingAddress(address);
      setSubmitting(StepperButtons.SUBMITTING.NEXT);
      try {
        if (refs[methodSelect]?.current?.nextStep) {
          await refs[methodSelect].current.nextStep();
        }
      } finally {
        setSubmitting(null);
      }
    },
  });

  const nextStep = formik.submitForm;

  const backStep = () => {
    $actions.setBillingAddress(formik.values.address);
    if (refs[methodSelect]?.current?.backStep) {
      refs[methodSelect].current.backStep();
    } else {
      $actions.setStep($state.step - 1);
    }
  };

  const deliveryDays = $state.device.fakeDefect ? 4 : 3;

  const initialDeliveryDate = () => {
    if (isWeekend(add(new Date(), { days: 3 }))) return add(new Date(), { days: deliveryDays + 2 });
    if (Holidays.isHoliday(add(new Date(), { days: 3 }))) {
      if (isFriday(add(new Date(), { days: 3 }))) return add(new Date(), { days: deliveryDays + 3 });
      return add(new Date(), { days: deliveryDays + 1 });
    }
    if (isFriday(new Date())) return add(new Date(), { days: deliveryDays + 2 });
    return add(new Date(), { days: deliveryDays });
  };

  const [deliveryDate, setDeliveryDate] = React.useState(initialDeliveryDate);

  React.useEffect(() => {
    $actions.setDeliveryData({ schedule_delivery: format(deliveryDate, 'dd-MM-yyyy') });
  }, [$actions]);

  return (
    <>
      <Title label="Dados para pagamento" />
      <BoxCheckout />
      <Address formik={formik} />
      <Title label="Selecione o método" />
      <RadioGroupPayment
        handleRadioChange={handleRadioChange}
        methodSelect={methodSelect}
        options={[
          {
            icon: 'schedule',
            value: 'afterRepairPayment',
            label: 'Pagar após o reparo',
            component: (<AfterRepairPaymentMethod ref={afterRepairPaymentRef} />),
          },
        ]}
      />
      <StepperButtons
        isSubmitting={isSubmitting}
        nextStep={nextStep}
        backStep={backStep}
        nextText="Confirmar e revisar"
      />
    </>
  );
}

PaymentMethod.propTypes = propTypes;
PaymentMethod.defaultProps = defaultProps;

export default connect(PaymentMethod);
